// src/store/modules/sendbird/getters.js
export default {
  // Returns a single, deduped, time-sorted array of messages for a channel,
  // whether state.messages[channelUrl] is an array (Option A) OR {history, live}.
  messages: (state) => (channelUrl) => {
    const bucket = state.messages?.[channelUrl];

    // Flatten to a single array
    let combined = [];
    if (Array.isArray(bucket)) {
      combined = bucket; // Option A (flat)
    } else if (bucket && (Array.isArray(bucket.history) || Array.isArray(bucket.live))) {
      combined = [...(bucket.history || []), ...(bucket.live || [])]; // legacy shape
    }

    // Dedupe by common id fields
    const seen = new Set();
    const deduped = combined.filter((msg) => {
      const key =
        msg.messageId || msg.id || msg.Id || msg.reqId || msg.requestId;
      if (!key) return true; // no id: keep
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    // Sort by createdAt; handle number or string
    const toTs = (v) => {
      if (v == null) return 0;
      if (typeof v === 'number') return v;
      const t = Date.parse(v);
      return Number.isNaN(t) ? 0 : t;
    };

    return deduped.slice().sort((a, b) => toTs(a.createdAt) - toTs(b.createdAt));
  },

  // Returns the "by type" bucket for callers that still expect { history, live }.
  // If we only have a flat array (Option A), expose it as history with empty live.
  messagesByType: (state) => (channelUrl) => {
    const bucket = state.messages?.[channelUrl];
    if (bucket && (Array.isArray(bucket.history) || Array.isArray(bucket.live))) {
      return {
        history: bucket.history || [],
        live: bucket.live || [],
      };
    }
    // Flat array → map it to { history, live: [] }
    return {
      history: Array.isArray(bucket) ? bucket : [],
      live: [],
    };
  },

  chatHistory: (state) => (channelUrl) => state.chatHistory?.[channelUrl] || {},

  loadedMessages: (state) => (channelUrl) => state.loadedMessages?.[channelUrl] || [],

  isTyping: (state) => state.isTyping,

  directMessageCount: (state) => state.directMessageCount,

  cleanMessage: (state) => state.cleanMessage,

  files: (state) => state.files,

  channels: (state) => state.channels,

  token: (state) => state.token,
};
